import { Link, useLocation } from 'react-router-dom';
import { Calendar, Settings, Globe } from 'lucide-react';
import { cn } from '../lib/utils';

export const Header = ({ isInternational, setIsInternational }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <header 
      className="glass-header sticky top-0 z-50 border-b border-slate-200 dark:border-slate-800"
      data-testid="main-header"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center gap-2"
            data-testid="logo-link"
          >
            <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center">
              <Calendar className="text-white" size={24} />
            </div>
            <div className="hidden sm:block">
              <span 
                className="text-xl font-bold text-slate-900 dark:text-white uppercase tracking-tight"
                style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
              >
                A Minha Corrida
              </span>
            </div>
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-2">
            {!isAdmin && (
              <button
                onClick={() => setIsInternational(!isInternational)}
                className={cn(
                  'flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider transition-all',
                  isInternational 
                    ? 'bg-red-600 text-white' 
                    : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'
                )}
                data-testid="international-toggle"
              >
                <Globe size={16} />
                <span className="hidden sm:inline">Internacional</span>
              </button>
            )}
            
            <Link
              to={isAdmin ? '/' : '/admin'}
              className={cn(
                'flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider transition-all',
                isAdmin 
                  ? 'bg-slate-900 dark:bg-white text-white dark:text-slate-900' 
                  : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'
              )}
              data-testid="admin-link"
            >
              <Settings size={16} />
              <span className="hidden sm:inline">{isAdmin ? 'Calendário' : 'Admin'}</span>
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
